import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import { useUserStore } from '~/store/user';

/**
 * The signed-in user's own account name, for the scope chip on the account dashboards (ENG-5850).
 *
 * `/v1/auth/userinfo` carries `accountId` but no name, so this reads it from the accounts endpoint —
 * which permits a caller to read their own account, so no extra authorization is involved. Failure is
 * silent: the chip simply doesn't render, which is better than blocking the dashboard on a label.
 */
export const useAccountName = () => {
  const { identity } = useGateway();
  const { user } = storeToRefs(useUserStore());

  const accountName = ref('');

  const load = () => {
    const accountId = user.value?.accountId;
    if (!accountId) return;

    identity.accounts.findOne(accountId).subscribe({
      error: () => (accountName.value = ''),
      next: response => (accountName.value = response?.data?.name ?? ''),
    });
  };

  return { accountName, load };
};
